import React, { Fragment } from 'react';
import HtmlInput from './Input';

const TextInput = ({
  Input = HtmlInput,
  placeholder = '',
  isHidden,
  autoFocus,
  value,
  onChange,
  isDisabled,
  name = 'text',
  error,
  hasError,
  htmlType,
  ...rest
}) => (
  <Fragment>
    <Input
      id={name}
      type={isHidden ? 'hidden' : htmlType ? htmlType : 'text'}
      name={name}
      autoComplete="on"
      autoCapitalize="off"
      autoCorrect="off"
      placeholder={placeholder}
      autoFocus={autoFocus || false}
      checked={!!value}
      value={value || ''}
      onChange={e =>
        onChange
          ? onChange(
              htmlType === 'checkbox' ? e.target.checked : e.target.value
            )
          : undefined
      }
      disabled={isDisabled}
      {...rest}
    />
  </Fragment>
);

export default TextInput;